import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "vehicle-report-grid-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScaleLoader = _resolveComponent("ScaleLoader")!
  const _component_ExportButtons = _resolveComponent("ExportButtons")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_ScaleLoader, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ExportButtons, {
          csv: _ctx.exportGridsToExcel,
          pdf: _ctx.exportGridsToPdf,
          xlsx: _ctx.exportGridsToExcel
        }, null, 8, ["csv", "pdf", "xlsx"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_DxDataGrid, {
            ref: _ctx.dataGridRef,
            "allow-column-reordering": true,
            "allow-column-resizing": true,
            "column-auto-width": true,
            "column-hiding-enabled": true,
            class: "vehicle-report-grid",
            "data-source": _ctx.store,
            "hover-state-enabled": true,
            "remote-operations": _ctx.remoteOperations,
            "row-alternation-enabled": true,
            "show-borders": true,
            "show-column-lines": true,
            "show-row-lines": false
          }, {
            "additional-info-cell-template": _withCtx(({ data }) => [
              _createElementVNode("p", null, "Start: " + _toDisplayString(data.data.place_start), 1),
              _createElementVNode("p", null, "Stop: " + _toDisplayString(data.data.place_stop), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DxHeaderFilter, { visible: false }),
              _createVNode(_component_DxPaging, {
                "page-index": 0,
                "page-size": 25
              }),
              _createVNode(_component_DxPager, {
                "allowed-page-sizes": [10, 20, 25],
                "show-info": true,
                "show-navigation-buttons": true,
                "show-page-size-selector": true
              }),
              _createVNode(_component_DxFilterRow, { visible: true }),
              _createVNode(_component_DxColumnFixing, { enabled: true }),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.reports.weeklyReport.weeklyReport')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxColumn, {
                    "allow-filtering": true,
                    "allow-header-filtering": false,
                    caption: _ctx.$t('components.reports.weeklyReport.date'),
                    "filter-operations": _ctx.allowedOperations,
                    "customize-text": _ctx.dateRangeCell,
                    "data-field": "date_from"
                  }, null, 8, ["caption", "filter-operations", "customize-text"]),
                  _createVNode(_component_DxColumn, {
                    "allow-filtering": true,
                    "allow-header-filtering": false,
                    caption: _ctx.$t('components.reports.weeklyReport.weekNumber'),
                    "filter-operations": _ctx.allowedOperations,
                    "data-field": "week_number"
                  }, null, 8, ["caption", "filter-operations"]),
                  _createVNode(_component_DxColumn, {
                    "allow-filtering": true,
                    "allow-header-filtering": false,
                    caption: _ctx.$t('components.reports.weeklyReport.drivingTime'),
                    "filter-operations": _ctx.allowedOperations,
                    "customize-text": _ctx.formatMinutesCell,
                    "data-field": "drive_time"
                  }, null, 8, ["caption", "filter-operations", "customize-text"]),
                  _createVNode(_component_DxColumn, {
                    "allow-filtering": true,
                    "allow-header-filtering": false,
                    caption: _ctx.$t('components.reports.weeklyReport.additionalInfo'),
                    "filter-operations": _ctx.allowedOperations,
                    "cell-template": "additional-info-cell-template",
                    "data-field": "place_start"
                  }, null, 8, ["caption", "filter-operations"])
                ]),
                _: 1
              }, 8, ["caption"])
            ]),
            _: 1
          }, 8, ["data-source", "remote-operations"])
        ])
      ]))
}